import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the tax services menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: string[]
 *  ldFlags: object
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getTaxServicesMenu({
  businessEntityUuid, entitlements, ldFlags, order
}) {
  const { enableZeroStageTaxServicesPage } = ldFlags;
  const hasTaxEntitlements = entitlements.has('tax_annual_filing')
    || entitlements.has('tax_unlimited_advice')
    || entitlements.has('tax_annual_filing_prior_year');
  const showZeroStagePage = !hasTaxEntitlements && enableZeroStageTaxServicesPage;

  if (!hasTaxEntitlements && !showZeroStagePage) {
    return {};
  }

  return processMenu({
    title: 'Tax Services',
    itemId: 'taxservices',
    icon: 'calculator-fill.svg',
    path: generatePath(ROUTES.entityMoney, { businessEntityUuid, '*': 'tax-services' }),
    order
  });
}
